import { createFileRoute } from "@tanstack/react-router";

import SongsCreateUpdate from "@/features/songs/SongsCreateUpdate";

export const Route = createFileRoute("/_auth/songs/update/$id")({
  component: () => <SongsCreateUpdate key="update" />,
});
